/* eslint-disable @typescript-eslint/no-shadow */
import { Action } from '@ngrx/store';
import { AccountInformation } from '../../interfaces/account-information.interface';
import { Manager } from 'src/app/interfaces/manager.interface';
import { User } from '../../models/user.model';

export enum ActionTypes {
    LoadProfile                 = '[Account] - Load Profile',
    LoadProfileComplete         = '[Account] - Load Profile complete',
    LoadAccount                 = '[Account] - Load Account',
    LoadAccountComplete         = '[Account] - Load Account complete',
    LoadSuccessManager          = '[Account] - Load Succes Manager',
    LoadSuccessManagerComplete  = '[Account] - Load Succes Manager complete',
}

export class LoadProfile implements Action {
    readonly type = ActionTypes.LoadProfile;
    constructor(public payload?: {reload: boolean}) {}
}

export class LoadProfileComplete implements Action {
    readonly type = ActionTypes.LoadProfileComplete;
    constructor(public payload: User) {}
}

export class LoadAccount implements Action {
    readonly type = ActionTypes.LoadAccount;
}

export class LoadAccountComplete implements Action {
    readonly type = ActionTypes.LoadAccountComplete;
    constructor(public payload: AccountInformation) {}
}

export class LoadSuccessManager implements Action {
    readonly type = ActionTypes.LoadSuccessManager;
}

export class LoadSuccessManagerComplete implements Action {
    readonly type = ActionTypes.LoadSuccessManagerComplete;
    constructor(public payload: Manager) {}
}

export type MyAccountActions =
  | LoadProfile
  | LoadProfileComplete
  | LoadSuccessManager
  | LoadSuccessManagerComplete
  | LoadAccount
  | LoadAccountComplete;
